import DialogComponent from "components/Dialog";

export default class newPriceDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogFor: "general",
            currentDate: null,
            mode: "new",
            info: null,
        };
    }

    title = "price.createNewPrice";

    show(mode, info, hidCb) {
        this.state.mode = mode;
        this.state.info = info;
        this.dialogTitle = mode === "new" ? "price.createNewPrice" : "price.createNewPriceOld";
        this.hidCb = hidCb;
        super.show();
    }

    onShow() {
    }

    async save() {
        const { currentDate, mode, info } = this.state;

        if (currentDate) {
            this._helper.showLoading();

            const infoPrice = {
                dateFrom: currentDate,
                comment: this.commentInput.value,
                createdBy: this._helper.getProfileId()
            };

            if (!info.priceCategories || info.priceCategories.length < 0) {
                infoPrice.priceCategories = [
                    {
                        domainId: 345,
                        linkId: 0,
                        historyId: 373,
                        value: 0,
                        rating: 0,
                        typeId: 0,
                        linkIdList: null,
                        code: null,
                        altCode: null,
                        noDiscount: false,
                        items: [],
                        name: "root",
                    }
                ];
            }

            const resp = (mode === "new" || infoPrice.priceCategories) ? await this._request.priceLists.add(infoPrice) :
                await this._request.priceLists.clone(info.id, infoPrice);

            this._helper.hideLoading();

            if (resp?.data) {
                this.hide();

                if (this.hidCb?.apply)
                    this.hidCb(resp?.data);
            }
        }
    }

    renderContent() {
        const { mode, info, currentDate } = this.state;
        return (
            <div className="content flex col gap16">
                {mode === "old" && <div>
                    {this.insertRowInfo("price.onBase", `${this.tr("menu.price")} ${info.validity}`)}
                </div>}
                <div className="flex flex1">
                    {this.insertSelectDate({
                        label: "price.startDate",
                        pastOff: true,
                        onChange: this.changeState.bind(this, "currentDate"),
                        defaultValue: currentDate,
                    })}
                </div>
                {this.insertTextarea({
                    ref: el => this.commentInput = el,
                    label: "main.comment",
                    placeHolder: "price.description"
                })}
            </div>
        );
    }
}

